// extracted by mini-css-extract-plugin
export default {"main-content":"rZ_Xt","no-small":"pLP9O","logo":"ETRuS","home":"gomKJ"};